var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Brand from './components/Brand';
import Navigation from './components/Navigation';
import LogoutButton from './components/LogoutButton';
import LaunchNotesButton from './components/LaunchNotesButton';
import classnames from 'classnames';
import auth from '../../lib/auth';
var StyledHeader = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  grid-area: head;\n  font-size: 17px;\n  background-color: #fff;\n  padding: 1rem;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n  justify-content: space-between;\n  &.center{\n    justify-content: center;\n  }\n"], ["\n  grid-area: head;\n  font-size: 17px;\n  background-color: #fff;\n  padding: 1rem;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n  justify-content: space-between;\n  &.center{\n    justify-content: center;\n  }\n"])));
var NavigationAndBrand = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var RightSideButtons = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Header = function () {
    var isAuthenticated = auth.isAuthenticated;
    return (_jsxs(StyledHeader, __assign({ className: classnames({ center: !isAuthenticated }) }, { children: [_jsxs(NavigationAndBrand, { children: [_jsx(Brand, {}), isAuthenticated &&
                        _jsx(Navigation, {})] }), isAuthenticated &&
                _jsxs(RightSideButtons, { children: [_jsx(LaunchNotesButton, {}), _jsx(LogoutButton, {})] })] })));
};
export default Header;
var templateObject_1, templateObject_2, templateObject_3;
